module.exports = __webpack_public_path__ + "img/category-casino.e59d481e.png";